module.exports = __webpack_public_path__ + "static/media/CTA-google.de2582c0.png";